import * as React from "react";
import { useState, useEffect } from "react";
import { Feed, FeedItemReceiveGold } from "../../../server/feed/buildfeed";
import { useUser } from "../state";
import { api } from "../api";
import { TwoColumnView, Page } from "../DesignSystem/formatting/TwoColumnView";
import { FeedView } from "./FeedView";
import { OngoingContests } from "./OngoingContests";
import { TopRecentTracks } from "./TopRecentTracks";
import { PatreonReminder } from "./PatreonReminder";
import { FeedElementStatsJSX } from "./FeedElementStatsJSX";
import { FeedItemGoldReasons } from "./FeedItemGoldReasons";

export function FeedPage(): JSX.Element {
  const userState = useUser();
  const user = userState.type === "logged-in" ? userState.user : undefined;
  const [feed, setFeed] = useState<Feed>([]);

  useEffect(() => {
    api.get("/api/feed").then(setFeed);
  }, []);

  if (feed.length === 0) {
    return <div> Loading insanity </div>;
  }

  const topOfMonth = feed.filter((x) => x.type === "topofmonth")[0];
  const statsSection = feed.filter((x) => x.type === "stats")[0];
  const goldSection = feed.filter((x) => x.type === "receive-gold");

  const filteredFeed = feed.filter(
    (x) => x.type !== "topofmonth" && x.type !== "stats"
  );

  const bottomSection = filteredFeed.filter(
    (x) => !["votes-required", "event"].includes(x.type)
  );
  const events = filteredFeed.filter((x) => x.type === "event");
  const compos = filteredFeed.filter((x) => x.type === "upcoming-contest");

  return (
    <Page>
      {/* Beta Banner */}
      <TwoColumnView
        left={<FeedView items={bottomSection} />}
        rightTop={
          <OngoingContests
            title="Upcoming"
            contestsJSON={[...compos, ...events]}
            user={user}
          />
        }
        rightBottom={
          <>
            <TopRecentTracks topOfMonth={topOfMonth} />
            <PatreonReminder />
            <FeedElementStatsJSX stats={statsSection} />
            {goldSection && goldSection[0] && (
              <FeedItemGoldReasons
                item={goldSection[0] as FeedItemReceiveGold}
              />
            )}
          </>
        }
      />
    </Page>
  );
}
